<template>
  <div id="container" :class="{'newYear':isBGLogin}">
    <div v-if='!isGoogle'>
      <div id="LoginBox">
        <div class="login_logo">
          <a href="/" class="logo"></a>
          <h1>{{$t('base.signUpTo')}}</h1>
        </div>
        <el-form class="register_box" :model="ruleForm" :rules="rules" ref="ruleForm">
          <!-- 国籍和手机号 -->
          <el-form-item class="login_form_item" prop="TelPhone">
            <!-- 国籍 -->
            <div class="locationPhoneBox">
              <div class="countries" v-if="ruleForm.MemberSource!=''">
                <img :src="ruleForm.LocationIcon" alt="">
              </div>
              <el-select class="login_ipt" :class="ruleForm.MemberSource!=''?'nolocation':''" placeholder="" v-model="ruleForm.MemberSource" popper-class='location' @change='changeLocation'>
                <el-option class="locationelOption" :label="item.EnName" :value="item.Code" v-for="(item,index) in locationOption" :key='index'>
                  <div class="locationOption">
                    <img :src="item.IconUrl">
                    <span>{{item.EnName}}</span>
                  </div>
                </el-option>
              </el-select>
              <div class="nationCode">
                {{ruleForm.AreaCode}}
              </div>
            </div>
            <!-- 手机号 -->
            <el-input class="login_ipt email" v-model="ruleForm.TelPhone" :placeholder="$t('rules.phoneWarning')"></el-input>
          </el-form-item>
          <!-- 用户名 -->
          <el-form-item class="login_form_item" prop="NickName">
            <el-input class="login_ipt" v-model="ruleForm.NickName" minlength='6' :placeholder="$t('rules.usernameWarning')" @input="forbidInput('NickName')">
            </el-input>
          </el-form-item>
          <!-- 验证码 -->
          <div class="code_box">
            <el-form-item class="login_form_item" prop="Code">
              <el-input class="login_ipt" v-model="ruleForm.Code" minlength='6' maxlength='6' :placeholder="$t('rules.enterCode')" :readonly='readonly' @focus='focusReadonly' :validate-event="false"></el-input>
            </el-form-item>
            <div class="code text_blue" v-if="isCode" @click="ruleForm.TelPhone?getCode('ruleForm'):''" :class="!ruleForm.TelPhone?'noemail':''"><span>{{$t('base.verify')}}</span></div>
            <div class="code Resend" v-if="!isCode"><span>{{$t('base.resendIn')}} {{ times }}s</span></div>
          </div>
          <!-- 邮箱 -->
          <el-form-item class="login_form_item" prop="EMail">
            <el-input class="login_ipt" v-model="ruleForm.EMail" :placeholder="$t('base.email')">
            </el-input>
          </el-form-item>
          <!-- 密码 -->
          <el-form-item class="login_form_item" prop="Password">
            <el-input class="login_ipt" :type="flagType" v-model="ruleForm.Password" minlength='6' maxlength='20' :placeholder="$t('base.enterPassword')" :readonly='readonly' @focus='focusReadonly' @input="forbidInput('Password')">
              <i slot="suffix" class="showing" :class="[flag == true?'show':'noshow']" v-show="ifshow" @click="getFlag()" />
            </el-input>
          </el-form-item>
          <!-- 提交按钮 -->
          <div class="forgot">{{$t('rules.pwdTip')}}</div>
          <el-input class="login_ipt PromoCode" v-model="ruleForm.InviteCode" :placeholder="$t('base.PromoCode')">
          </el-input>
          <div class="googleInfoBtn">
            <el-button class="text_btn" type="primary" :disabled="disabled" @click="submitForm('ruleForm')">{{$t('base.signUp')}}</el-button>
            <google-identity @getData="getGoogleData" />
          </div>
          <!-- 合规文档 -->
          <div class="terms_checked">
            <el-checkbox v-model="checkbox" :label="1">{{radioNumber}}</el-checkbox>
            <div>
              <i18n path="base.agreeTo" tag="p" >
          <router-link class="text_blue" :to="{path:'/terms/privacy?type=2'}" target="_blank">{{$t('base.service')}}</router-link>
          <router-link class="text_blue" :to="{path:'/terms/privacy?type=1'}" target="_blank">{{$t('base.privacy')}}</router-link>
          </i18n>
              <!-- {{$t('base.agreeTo')}} <router-link class="text_blue" :to="{path:'/terms/privacy?type=2'}" target="_blank">{{$t('base.service')}}
              </router-link> {{$t('base.and')}} <router-link class="text_blue" :to="{path:'/terms/privacy?type=1'}" target="_blank">{{$t('base.privacy')}}
              </router-link> -->
            </div>
          </div>
          <!-- <div class="terms">
          <p>1. {{$t('alert.noEditNickname')}}</p>
          <p>2. {{$t('alert.noEditPhone')}}</p>
        </div> -->
          <!-- 回登录 -->
          <div class="account_box">
            {{$t('symbol.member')}} <router-link class="text_blue" :to="{path:'/login'}">{{$t('base.signIn')}}</router-link>
          </div>
        </el-form>
        <div class="isIframe" v-if="isIframe">
          <span class="closeSpan" @click="isIframe=false">X</span>
          <iframe id="ifcheckbox" :src="url" name="check" class="check_box" scrolling="no"></iframe>
        </div>
      </div>
    </div>
    <!-- google绑定 -->
    <google-binding v-if="isGoogle&&gdata.type==1&&env!='production'" :gdata='gdata' :locationOption='locationOption' />
    <!-- google注册 -->
    <google-register v-if="isGoogle&&gdata.type==0&&env!='production'" :gdata='gdata' :locationOption='locationOption' />
  </div>
</template>
<script>
import GoogleIdentity from '@/components/google-identity' //  google登录
import GoogleBinding from '@/components/googlebinding' //  google绑定
import GoogleRegister from '@/components/googleregister' //  google绑定
import { CensoredEmail, getUser, isEmoji } from "@/api/public";
export default {
  name: 'index',
  components: { GoogleIdentity, GoogleBinding, GoogleRegister },
  data() {
    var userValidate = (rule, value, callback) => {
      var msg = this.$t('rules.invalidPhone')
      if (this.smsMsg) {
        msg = this.smsMsg
        this.smsMsg = ""
        callback(new Error(msg));
      } else if (value === '') {
        callback(new Error(msg));
      } else if (value != '') {
        // 验证 美国，香港，澳门，台湾 手机号位数 香港，澳门 为8位，美国，台湾为10位，台湾第二位必定是9
        let reg = /^\d{6,}$/;
        if (this.ruleForm.MemberSource == 'HK' || this.ruleForm.MemberSource == 'MO') {
          // 香港 澳门
          reg = /^\d{8}$/;
        }
        if (this.ruleForm.MemberSource == 'US' || this.ruleForm.MemberSource == 'TWN'||this.ruleForm.MemberSource == 'TW') {
          // 美国 台湾
          reg = /^\d{10}$/;
        }
        //console.log('reg',reg,reg.test(value))
        if (reg.test(value)) {
          // 台湾
          if (this.ruleForm.MemberSource == 'TWN'||this.ruleForm.MemberSource == 'TW') {
            if (value.substring(1, 2) != '9') {
              callback(new Error(msg));
            }
            callback();
          }
          callback();
        } else {
          callback(new Error(msg));
        }
      } else {
        callback();
      }
    };
    var numSix = (rule, value, callback) => {
      if (value.length > 0 && value.length < 6) {
        var name = 'Password'
        if (rule.field == 'NickName') { name = 'NickName' }
        callback(new Error(name + this.$t('rules.pwdCharacter')));
      } else {
        callback();
      }
    };
    /**
     * 验证输入值是否包含中文字符的校验函数
     * @param {Object} rule 校验规则对象
     * @param {string} value 需要校验的值
     * @param {Function} callback 回调函数
     * @returns {void} 如果包含中文则返回错误信息,否则通过校验
     */
    var isChinese = (rule, value, callback) => {
      let reg = /[\u4E00-\u9FA5]/g;
      let ChineseLength = (value.match(reg) || []).length
      if (ChineseLength > 0) {
        var msg = this.$t('rules.isChinese')
        callback(new Error(msg));
      }

      callback();
    }
    return {
      env: process.env.NODE_ENV,
      gdata: '',
      isGoogle: false,
      isBGLogin: process.env.VUE_APP_LOGIN,
      checkUrl: process.env.VUE_APP_CMS + '/checkcode/index?mobile=', // 图片验证
      url:'',
      isIframe: false, // 图片验证
      locationOption: '', // 国家列表
      readonly: true,
      smsMsg: '',
      disabled: false, // 按钮禁用
      // checked: false,
      radioNumber: '', // 是否勾选查看合规条款
      checkbox: false, // 是否选中条款
      times: 120, // 默认倒计时120秒
      isCode: true, // 判断是否已在倒计时
      flagType: 'password', //密码切换状态
      flag: false, //密码切换状态
      ifshow: false, //是否显示查看密码的图标
      isUserData: null,
      ruleForm: {
        NickName: '',
        TelPhone: '',
        Password: '',
        Code: '',
        LocationIcon: '',
        LocationName: '',
        MemberSource: '',
        AreaCode: '',
        EMail: '',
        InviteCode: ''
      },
      rules: {
        // Location
        TelPhone: [
          //{ required: true, message: 'Invalid email. Please check and try again.', trigger: 'blur' },
          // 最少8位数字
          //{ pattern: /^\d{10}$/, message: 'Invalid Phone number. Please check and try again.', trigger: 'blur' },
          { validator: userValidate, trigger: 'blur' },
        ],
        NickName: [
          { required: true, message: this.$t('rules.nicknameRule'), trigger: 'blur' },
          { validator: numSix, trigger: 'blur' },
          { pattern: /^[^[\u4E00-\u9FA5]+$/, message: 'The nickname does not support Chinese characters.', trigger: 'blur' },
          //{ validator: isChinese, trigger: 'blur' },
          // { pattern: /^[_a-zA-Z0-9]+(\s+[_a-zA-Z0-9]+)*$/, message: 'nickname should be 6-20 characters', trigger: 'blur' },
        ],
        // location: [
        //   { required: true, message: 'Choose your Country', trigger: 'change' }
        // ],
        EMail: [
          { required: true, message: this.$t('rules.invalidEmailAgain'), trigger: 'blur' },
          { type: 'email', message: this.$t('rules.invalidEmailAgain'), trigger: 'blur' }
        ],
        Code: [
          { required: true, message: this.$t('rules.invalidCodeAgain'), trigger: 'blur' }, //, trigger: 'blur' 
        ],
        Password: [
          { required: true, message: this.$t('rules.pwdCharacterRule'), trigger: 'blur' },
          { validator: numSix, trigger: 'blur' },
          { pattern: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[0-9a-zA-Z\x21-\x7e]{6,20}$/, message: this.$t('rules.pwdRule'), trigger: 'blur' },
          //{ pattern: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])[0-9a-zA-Z]{6,20}$/, message: 'Password should contain at least 1 uppercase letter and 1 number',trigger: 'blur'},
        ]
      }
    }
  },
  created() {

    this.getNationIcons()
  },
  mounted() {
    let that = this
    window.addEventListener('keydown', function(e) {
      if (e.keyCode === 13) {
        that.submitForm('ruleForm')
      }
    })

    window.addEventListener("message", function(e) {
      //console.log(e)
      if (e.data == "checkcode") {
        that.getCodeOk()
        //console.log(e)
      }
    });
  },
  methods: {
    /**
     * 处理 Google 账号登录/注册逻辑
     * @param {Object} obj - Google 账号绑定信息,包含用户基本信息
     * @param {Object} gobj - Google 账号原始数据
     * @description 如果 Google 账号已绑定则直接登录,未绑定则提示用户选择绑定已有账号或注册新账号
     * @property {string} obj.AreaCode - 区号
     * @property {string} obj.ChineseToken - 中文令牌
     * @property {string} obj.EMail - 邮箱
     * @property {string} obj.HeadPortrait - 头像
     * @property {string} obj.Id - 用户ID
     * @property {boolean} obj.IsSeller - 是否为卖家
     * @property {string} obj.Language - 语言
     * @property {string} obj.MappingUserId - 映射用户ID
     * @property {string} obj.NickName - 昵称
     * @property {number} obj.Status - 状态
     * @property {string} obj.TelPhone - 电话号码
     */
    getGoogleData(obj, gobj) {
      let that = this
      if (obj) {
        // google账号已绑定，直接登录
        that.loading = true;
        that.disabled = true;
        const googleDate = {
          AreaCode: obj.AreaCode,
          ChineseToken: obj.ChineseToken,
          EMail: obj.EMail,
          HeadPortrait: obj.HeadPortrait,
          Id: obj.Id,
          IsSeller: obj.IsSeller,
          Language: obj.Language,
          MappingUserId: obj.MappingUserId,
          NickName: obj.NickName,
          Status: obj.Status,
          TelPhone: obj.TelPhone
        }
        getUser(googleDate)
        setTimeout(function() {
          that.loading = false;
          that.disabled = false;
        }, 1000)
      } else {
        // google账号，未绑定 ，跳转
        that.$confirm('之前已注册您有 Card Hobby 帐户吗？', '', {
          confirmButtonText: '绑定已有账号',
          cancelButtonText: '注册新账号',
          lockScroll: false
        }).then(() => {
          //绑定账号
          that.isGoogle = true
          gobj.type = 1
          that.gdata = gobj
        }).catch(() => {
          //注册账号
          that.isGoogle = true
          gobj.type = 0
          that.gdata = gobj
        });
      }
    },
    // 修改国家
    changeLocation(e) {
      let that = this
      that.locationOption.map(res => {
        if (res.Code == e) {
          that.ruleForm.MemberSource = res.Code //
          that.ruleForm.LocationIcon = res.IconUrl
          that.ruleForm.LocationName = res.EnName
          that.ruleForm.AreaCode = res.NationCode
        }
      })
      //console.log(that.ruleForm)
    },
    //获取全部国家图标地址
    getNationIcons() {
      let that = this
      this.$get(this.$interface.GetAllNationIcons, '').then(res => {
        if (res.Result != 0) {
          that.locationOption = res.Data
          that.ruleForm.MemberSource = res.Data[0].Code //
          that.ruleForm.LocationIcon = res.Data[0].IconUrl
          that.ruleForm.LocationName = res.Data[0].EnName
          that.ruleForm.AreaCode = res.Data[0].NationCode
        }
      })
    },
    focusReadonly() {
      this.readonly = false
    },
    forbidInput(e) {
      let num = 1
      if (e === 'Password') {
        num = 1
      } else if (e === 'NickName') {
        this.ruleForm.NickName = isEmoji(this.ruleForm[e], num)
        this.ruleForm.NickName = this.ruleForm.name.substring(0, 20);
      }
      this.ruleForm[e] = isEmoji(this.ruleForm[e], num)
      //是否显示查看密码的图标
      this.ifshow = false
      if (this.ruleForm.Password) {
        this.ifshow = true
      }
    },
    //密码切换状态
    getFlag() {
      this.flag = !this.flag
      this.flagType = this.flag ? 'text' : 'password' //text为显示密码；password为隐藏密码
      // console.log(this.flag,this.flagType)
    },
    // 获取验证码
    getCode(formName) {
      let that = this;
      that.smsMsg = ""
      // 获取验证码

      this.$refs[formName].validateField('TelPhone', (val) => {
        if (val == "") {
          // 手机获取验证码
          that.url = that.checkUrl + that.ruleForm.TelPhone + '&lang=en'
          that.isIframe = true;
          // 开始监听
        }
      });
    },
    getCodeOk() {
      let that = this;
      that.smsMsg = ""
      that.isIframe = false;
      that.isCode = false;
      that.timer = setInterval(() => {
        that.times--;
        if (that.times === 0) {
          that.times = 120;
          that.isCode = true;
          clearInterval(that.timer)
        }
      }, 1000)
      var data = { 'TelPhone': that.ruleForm.TelPhone, "type": 0, 'NationCode': that.ruleForm.AreaCode }
      this.$post(this.$interface.GetCode, data).then(res => {
        //console.log(res)
        if (res.Result != 0) {
          that.disabled = false;
        } else {
          that.times = 120;
          that.isCode = true;
          clearInterval(that.timer)
          that.smsMsg = res.Msg
          that.$refs['ruleForm'].validateField("TelPhone");
          that.isCode = true;
        }
      })
    },
    // 注册
    submitForm(formName) {
      let that = this;
      that.smsMsg = ""
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.checkbox == false) {
            this.$confirm(`<div style="padding: 0 24px;">` + that.$t('alert.toProceed') + ` <a href="#" class="text_blue">` + that.$t('base.service') + `</a> ` + that.$t('base.and') + ` <a href="#" class="text_blue">` + that.$t('base.privacy') + `</a>.</div>`, that.$t('base.notice'), {
                // showConfirmButton: true ,
                dangerouslyUseHTMLString: true,
                confirmButtonText: that.$t('base.agree'),
                cancelButtonText: that.$t('base.cancel'),
              }).then(() => {
                this.checkbox = true;
                that.submitForm('ruleForm')
              })
              .catch(() => {

              });
          } else {
            this.disabled = true;
            this.$post(this.$interface.Register, that.ruleForm).then(res => {
              if (res.Result != 0) {
                this.$message({
                  type: 'success',
                  duration: 1000,
                  message: 'Registered successfully!'
                });
                that.isUserData = res.Data
                getUser(that.isUserData)
              } else {
                that.$message({
                  type: 'error',
                  duration: 1000,
                  message: res.Msg
                });
              }
              that.disabled = false;
            })
          }
        }
      });
    },
    removeListener() {
      // 删除监听
      this.isIframe = false;
      window.removeEventListener('message', function(e) {});
      window.removeEventListener('keydown', function(e) {});

    }
  },
  beforeDestroy() {
    this.removeListener()
  }
}

</script>
<style scoped>
@import "../../../static/css/login.css";

#container {
  height: auto;
  padding: 50px 0;
  min-height: 100vh;
}

/deep/ .el-icon-arrow-up:before {
  /* margin: 0 0 0 15px; */
  color: #a0a0a0;
  font-weight: normal;
}

.PromoCode {
  margin: 0px 0 30px;
}

.locationOption {
  display: flex;
  align-items: center;
}

.locationOption img {
  width: 24px;
  height: 17px;
  margin-right: 10px;
}

/deep/ .locationelOption.hover,
.locationelOption:hover,
.locationelOption.selected {
  background-color: #f8f8f8;
}

.register_box .forgot {
  padding-bottom: 20px;
  padding-top: 2px;
}

.terms_checked {
  margin-bottom: 5px;
}

.terms {
  color: #a0a0a0;
  margin-bottom: 12px;
  line-height: 1.5;
}

</style>



// WEBPACK FOOTER //
// src/pages/shared/register.vue